import { Route, Routes, Navigate } from 'react-router-dom';
import { ErrorContextProvider } from '@/context/ErrorContext';
import '@/styles/prs-ui.scss';
import NotFound from '../NotFound/NotFound';
import ProductView from '../ProductView/ProductView';
import './MainContainer.scss';
import SubmissionsList from '../ProductList/SubmissionsList';
import ReleasesList from '../ProductList/ReleasesList';
import MerchProductView from '../MerchProductView/MerchProductView';
import MerchandiseReleasesList from '../ProductList/MerchandiseReleasesList';
import MerchandiseSubmissionsList from '../ProductList/MerchandiseSubmissionsList';
import { PermissionGuard } from '@/guards/PermissionGuard';
import { ProductViewModes } from '@/utils/productStateUtils';

function MainContainer() {
  return (
    <ErrorContextProvider>
      <Routes>
        {/*Base Routes*/}
        <Route path="/" Component={ReleasesList}></Route>
        <Route path="/Products" Component={SubmissionsList}></Route>
        <Route path="/Submissions" Component={SubmissionsList}></Route>

        {/*Physical Routes*/}
        <Route path="/Physical" Component={SubmissionsList}></Route>
        <Route path="/Physical/Products" Component={SubmissionsList}></Route>
        <Route path="/Physical/Submissions" Component={SubmissionsList}></Route>
        <Route path="/Physical/Releases" Component={ReleasesList}></Route>
        <Route
          path="/Physical/CreateProduct/Album/:id"
          element={
            <PermissionGuard redirectTo="/Physical/ProductDetails/Album/:id">
              <ProductView productViewMode={ProductViewModes.Edit} />
            </PermissionGuard>
          }
        />
        <Route
          path="/Physical/EditProduct/Album/:id"
          element={
            <PermissionGuard redirectTo="/Physical/ProductDetails/Album/:id">
              <ProductView productViewMode={ProductViewModes.Edit} />
            </PermissionGuard>
          }
        />
        <Route
          path="/Physical/ProductDetails/Album/:id"
          element={<ProductView />}
        ></Route>
        <Route
          path="/Physical/ChangeRequest/Album/:id"
          element={
            <PermissionGuard redirectTo="/Physical/ProductDetails/Album/:id">
              <ProductView productViewMode={ProductViewModes.ChangeRequest} />
            </PermissionGuard>
          }
        />
        <Route
          path="/Physical/ChangeRequestDetails/Album/:id/ChangeRequest/:crId"
          element={
            <ProductView
              productViewMode={ProductViewModes.ChangeRequestReadOnly}
            />
          }
        ></Route>
        {/*Merchandise Routes*/}
        <Route
          path="/Merchandise"
          Component={MerchandiseSubmissionsList}
        ></Route>
        <Route
          path="/Merchandise/Submissions"
          Component={MerchandiseSubmissionsList}
        ></Route>
        <Route
          path="/Merchandise/Releases"
          Component={MerchandiseReleasesList}
        ></Route>
        <Route
          path="/Merchandise/EditProduct/:id"
          element={
            <PermissionGuard redirectTo="/Merchandise/ProductDetails/:id">
              <MerchProductView productViewMode={ProductViewModes.Edit} />
            </PermissionGuard>
          }
        ></Route>
        <Route
          path="/Merchandise/CreateProduct/:id"
          element={
            <PermissionGuard redirectTo="/Merchandise/ProductDetails/:id">
              <MerchProductView productViewMode={ProductViewModes.Edit} />
            </PermissionGuard>
          }
        ></Route>
        <Route
          path="/Merchandise/ProductDetails/:id"
          element={<MerchProductView />}
        ></Route>
        <Route
          path="/Merchandise/ChangeRequest/:id"
          element={
            <PermissionGuard redirectTo="/Merchandise/ProductDetails/:id">
              <MerchProductView
                productViewMode={ProductViewModes.ChangeRequest}
              />
            </PermissionGuard>
          }
        />
        <Route
          path="/Merchandise/ChangeRequestDetails/:id/ChangeRequest/:crId"
          element={
            <MerchProductView
              productViewMode={ProductViewModes.ChangeRequestReadOnly}
            />
          }
        ></Route>

        {/* Special Routes*/}
        <Route path="/logout" element={<Navigate to="/logout" />}></Route>
        <Route path="/404" Component={NotFound} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>
    </ErrorContextProvider>
  );
}

export default MainContainer;
